import { generateTypes } from '../../utils/HttpReducerHelper';

const resendInvite = generateTypes('TEAMS', 'RESEND_INVITE');
const OPEN_RESEND_INVITE_MODAL = 'platfi-ui-app/TEAMS/OPEN_RESEND_INVITE_MODAL';
const CLOSE_RESEND_INVITE_MODAL = 'platfi-ui-app/TEAMS/CLOSE_RESEND_INVITE_MODAL';

export { resendInvite, OPEN_RESEND_INVITE_MODAL, CLOSE_RESEND_INVITE_MODAL };
